import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { IDS_TIPO_CLIENTE_JURIDICO } from '../../constants/tipo-cliente';
import { IClaseCliente } from '../../models/clientes/clase-cliente.model';
import { ITipoCliente } from '../../models/clientes/tipo-cliente.model';
import { ClientService } from '../../services/cliente.service';
import { ArchivosNivel1AutocompleteComponent } from '../archivos-nivel1-autocomplete/archivos-nivel1-autocomplete.component';
import { ArchivosNivel2AutocompleteComponent } from '../archivos-nivel2-autocomplete/archivos-nivel2-autocomplete.component';
import { ArchivosNivel3AutocompleteComponent } from '../archivos-nivel3-autocomplete/archivos-nivel3-autocomplete.component';
import { ArchivosNivel4AutocompleteComponent } from '../archivos-nivel4-autocomplete/archivos-nivel4-autocomplete.component';
import { ArchivosNivel5AutocompleteComponent } from '../archivos-nivel5-autocomplete/archivos-nivel5-autocomplete.component';
import { ArchivoCentralService } from '../../services/archivo-central.service';
import { CustomModalResetComponent } from '../custom-modal-reset/custom-modal-reset.component';
import { ArchivoService } from '../../services/archivo.service';
import { DescargarArchivo } from '../../services/download.service';

interface BandejaItem {
  actualizadoPor: string
  creadoPor: string
  fecha: string
  numero: string
  origen: string
  personaBandeja: string
  remitente: string
  titulo: string
  usuarioPrincipal: string
  idExpediente: number
  selected?: boolean
  documento: string
}

interface ListData {
  list: BandejaItem[]
  [key: string]: any
}

@Component({
  selector: 'app-buscar-archivo-migrado',
  templateUrl: './buscar-archivo-migrado.component.html',
  styleUrls: ['./buscar-archivo-migrado.component.scss']
})

export class BuscarArchivoMigradoComponent implements OnInit {

  @ViewChild('nivel1Component') nivel1Component: ArchivosNivel1AutocompleteComponent
  @ViewChild('nivel2Component') nivel2Component: ArchivosNivel2AutocompleteComponent
  @ViewChild('nivel3Component') nivel3Component: ArchivosNivel3AutocompleteComponent
  @ViewChild('nivel4Component') nivel4Component: ArchivosNivel4AutocompleteComponent
  @ViewChild('nivel5Component') nivel5Component: ArchivosNivel5AutocompleteComponent
  @ViewChild('archivoPreview') archivoPreview: CustomModalResetComponent
  
  formBusqueda: FormGroup;
  formFiltroAvanzado = new FormGroup({
    idResponsable: new FormControl(),
    idArea: new FormControl(),
    numeroArchivo: new FormControl(),
    estado: new FormControl(),
    fechaInico: new FormControl(),
    fechaFin: new FormControl(),
    fechaControl: new FormControl(),
    nivel1: new FormControl(),
    nivel2: new FormControl({ value: '', disabled: true }),
    nivel3: new FormControl({ value: '', disabled: true }),
    nivel4: new FormControl({ value: '', disabled: true }),
    nivel5: new FormControl({ value: '', disabled: true }),
  });

  @Input() mostrarVisorMigrado: boolean = false

  listData: any = { list: [] }
  cargandoLista = false;
  isSelected = false
  paginationPage = 1;
  paginationSize = 10
  searchInput = new FormControl('')
  nombreArchivoInput = new FormControl('')
  iframeData: any = null;
  nombreArchivo: any;
  uuidArchivo: any;
  loadingPreview = true;
  documentPreviewUrl: string;

  data: {
    list: any[],
    [key: string]: any
  } = {
      list: []
    };

  buscandoAdministrados: boolean = false;
  listTipoCliente: ITipoCliente[] = [];
  listClaseCliente: IClaseCliente[] = [];
  selectedClaseCliente: IClaseCliente[] = [];
  @Output() onSelected = new EventEmitter();
  @Input() set closeMosal(closed: boolean) {
      //this.limpiarBusqueda();
      this.showAddFolder = false;
      alert('cerrado')
  }
  IDS_TIPO_CLIENTE_JURIDICO = IDS_TIPO_CLIENTE_JURIDICO;
  showAddFolder = false;
  flgEdit = false;
  idCliente: number;
  loadConsultaCliente = false;

  archivoSelected = [];

  formValues = null;

  constructor(
    public descargas: DescargarArchivo,
    private _centralArchiveService: ArchivoCentralService,
    private archivoService: ArchivoService
  ) {}

  ngOnInit(): void {
     this.cargarRegistros();
    //  this.mostrarVisorMigrado = false;
  }
  
  cargarRegistros(criterio?: string) {
  
    const values = this.formFiltroAvanzado.getRawValue()
    const body = {
      size: (this.paginationSize).toString(),
      page: (this.paginationPage).toString(),
      nombreArchivo: this.nombreArchivoInput.value,
      criterio: this.searchInput.value,
      nivel1: values.nivel1,
      nivel2: values.nivel2,
      nivel3: values.nivel3,
      nivel4: values.nivel4,
      nivel5: values.nivel5,
    }
    const callback = (resp: ListData) => {
      this.listData = resp
      this.cargandoLista = false;
    }

    const errorCallback = (err) => {
      alert('Error al cargar la bandeja. Recargue la página para intentar de nuevo')
    }

    this.cargandoLista = true;
    this.listData.list = []
    this._centralArchiveService.getArchivosMigradosByPaginationList(body).then(callback).catch(errorCallback)
  }

  filterSubmitHandle() {
    this.cargarRegistros()
  }

  clearAdvancedSearch(event?) {
    this.nivel1Component.cleanControl()
    this.nivel2Component.cleanControl()
    this.nivel3Component.cleanControl()
    this.nivel4Component.cleanControl()
    this.nivel5Component.cleanControl()
    this.nombreArchivoInput.setValue('')
    this.searchInput.setValue('')

    this.archivoSelected = [];

    if (event?.reload) {
      this.cargarRegistros()
    }
  }

  previusPage() {
    if (!this.listData.hasPreviousPage) return
    this.paginationPage--
    this.cargarRegistros()
  }

  nextPage() {
    if (!this.listData.hasNextPage) return
    this.paginationPage++
    this.cargarRegistros()
  }

  addAdministrado(): void {
    this.flgEdit = false;
    this.showAddFolder = true;
  }

  abrirArchivo(uuidArchivo,nombreArchivo) {
    console.log("archivo uuid::::::",uuidArchivo, nombreArchivo)
    // const { uuidArchivo, nombreArchivo } = item;
    this.iframeData = null;
    this.nombreArchivo = nombreArchivo
    this.uuidArchivo = uuidArchivo
    this.loadingPreview = true
    this.archivoPreview.open()
    this.documentPreviewUrl = '';
    this.archivoService.getUrlAlfrescoArchivo(uuidArchivo).then(resp => {
      console.log(resp)
      this.documentPreviewUrl = resp.data.mensaje + '&_date=' + new Date().getTime()
      this.getIframeUrl()
    });

  }

  getIframeUrl() {
    try {
      this.iframeData = this.documentPreviewUrl
      this.frameLoaded()
    } catch (err) {
      console.log(err.status)
    }
  }

  frameLoaded() {
    this.loadingPreview = false
  }

  changeArchivoEnvio(archivoEnvio, event) {
    if (event.target.checked) {
      const exists = this.ifSelected(archivoEnvio)
      if (!exists) {
        this.archivoSelected.push(archivoEnvio)
      }
    } else {
      this.archivoSelected = this.archivoSelected.filter(
        m => m.idArchivoMigrado != archivoEnvio.idArchivoMigrado
      )
    }
  }

  ifSelected(archivoEnvio): boolean {
    return Boolean(this.archivoSelected.filter(
      m => m.idArchivoMigrado == archivoEnvio.idArchivoMigrado
    ).length)
  }

  selectArchivo(): void {
    this.onSelected.emit(this.archivoSelected);
    this.data.list = [];
    this.showAddFolder = false;
    this.flgEdit = false;
    this.archivoSelected = []
    this.mostrarVisorMigrado = false;
  }

  actualizarVisorPdf( estado: boolean ) {
    this.mostrarVisorMigrado = estado;   
  }

}
